import { getOnlineUsersAdminAPI } from "./api"

export function getOnlineUsersAdmin() {
    return new Promise((resolve, reject) => {
        getOnlineUsersAdminAPI().then(res => resolve(res)).catch(err => reject(err))
    })
}
